import { Observable } from "rxjs";
import { BsDto } from "../../INTEGRA_Shop_Client";
import { InjectionToken } from "@angular/core";

export abstract class IBsService {

  abstract bsGet(): Observable<BsDto | undefined>;

}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IBsServiceToken = new InjectionToken<IBsService>('IBsServiceToken');
